import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { filterTables, OCCUPANCY_LABELS, OCCUPANCY_OPTIONS, SORT_OPTIONS, sortTables, STATUS_OPTIONS, TABLE_TYPES } from "../TrucoUtilities/lobby.utils";
import { RadioGroup } from "../TrucoUtilities/RadioGroup";
import { TablesList } from "./TablesList";
import { TableCard } from "./TableCard";
import { FaArrowUp } from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import { FaPowerOff } from "react-icons/fa";


export const LobbyScreen = forwardRef((props, ref) => {
    const [tables, setTables] = useState([])
    const [selectedType, setSelectedType] = useState('PUBLIC');
    const [selectedStatus, setSelectedStatus] = useState('ALL');
    const [selectedSeats, setSelectedSeats] = useState('all');
    const [selectedOccupancy, setSelectedOccupancy] = useState('all');
    const [sortKey, setSortKey] = useState('SEATS_AVAILABLE');
    const [sortDirection, setSortDirection] = useState('desc');
    const getInitialScreenState = () => ({
        isLargeScreen: window.innerWidth >= 767,
        isPortrait: window.innerHeight > window.innerWidth
    });

    const initial = getInitialScreenState();

    const [isLargeScreen, setIsLargeScreen] = useState(initial.isLargeScreen);
    const [isPortrait, setIsPortrait] = useState(initial.isPortrait);


    useImperativeHandle(ref, () => ({
        setTables,
        getTableDetails: (tableId) => tables.find(ele => ele.tableId === tableId)
    }), [tables])

    function debounce(func, delay) {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func(...args), delay);
        };
    }

    useEffect(() => {
        const handleResize = debounce(() => {
            setIsLargeScreen(window.innerWidth >= 767);
            setIsPortrait(window.innerHeight > window.innerWidth)
        }, 200);
        handleResize()
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const seatsOptions = useMemo(
        () =>
            Array.from(new Set(tables.map((t) => t.numberOfSeats))).sort(
                (a, b) => a - b
            ),
        [tables]
    );

    const visibleTables = useMemo(() => {
        const filtered = filterTables(tables, {
            type: selectedType,
            status: selectedStatus,
            seats: selectedSeats,
            occupancy: selectedOccupancy,
        });
        return sortTables(filtered, sortKey, sortDirection);
    }, [
        tables,
        selectedType,
        selectedStatus,
        selectedSeats,
        selectedOccupancy,
        sortKey,
        sortDirection,
    ]);

    const joinTable = (tableId) => {
        props.sendOf({ type: 'JOIN_TABLE', payload: { tableId: tableId } })
    }

    const exitLobby = () => {
        window.close()
    }

    return (
        <div className="lobby_screen">
            <h1 className="lobby_title">TRUCO</h1>
            <FaPowerOff className="truco-exit-lobby" onClick={exitLobby} />
            {/* Filters */}
            <div className="filters-bar">
                {/* Status */}
                {/* <RadioGroup
                    title="Status"
                    options={[...STATUS_OPTIONS]}
                    value={selectedStatus}
                    onChange={setSelectedStatus}
                /> */}


                {/* Seats */}
                {/* <RadioGroup
                    title="Seats"
                    options={["all", ...seatsOptions]}
                    value={selectedSeats}
                    getLabel={(v) => (v.toString().toLowerCase() === 'all' ? 'ALL' : `${v}`)}
                    onChange={setSelectedSeats}
                /> */}

                {/* Occupancy */}
                {/* {!(!isPortrait && isLargeScreen) && < RadioGroup
                    title="Seats"
                    options={OCCUPANCY_OPTIONS}
                    value={selectedOccupancy}
                    getLabel={(o) => (o.toString().toLowerCase() === 'all' ? 'ALL' : OCCUPANCY_LABELS[o])}
                    onChange={setSelectedOccupancy}
                />} */}

                {/* Sorting */}
                {/* <RadioGroup
                    title="Sort By"
                    options={SORT_OPTIONS.map((o) => o.key)}
                    value={sortKey}
                    customClassName=" sort-key-group"
                    getLabel={(k) =>
                        SORT_OPTIONS.find((o) => o.key === k)?.label
                    }
                    onChange={setSortKey}
                />

                <button
                    className='sorting-order-button'
                    onClick={() =>
                        setSortDirection((d) => (d === 'asc' ? 'desc' : 'asc'))
                    }
                >
                    {sortDirection === 'asc' ? <FaArrowUp /> : <FaArrowDown />}
                </button> */}


            </div>

            <div
                className="lobby_table_types"
                style={{
                    ['--tab-count']: TABLE_TYPES.length,
                    ['--active-index']: TABLE_TYPES.indexOf(selectedType),
                }}
                role="radiogroup"
            >
                {TABLE_TYPES.map((t) => (
                    <button
                        key={t}
                        type="button"
                        role="radio"
                        aria-checked={selectedType === t}
                        className={`lobby_type_btn ${selectedType === t ? 'truco-tab-active' : ''}`}
                        onClick={() => setSelectedType(t)}
                    >
                        {t}
                    </button>
                ))}
            </div>



            {/* Tables */}
            <div className="tables-list">
                {visibleTables.length > 0 ? (
                    // <TablesList visibleTables={visibleTables} joinTable={joinTable} />
                    (!isPortrait && isLargeScreen) ? (
                        <TablesList visibleTables={visibleTables} joinTable={joinTable} />
                    ) : (
                        <div className="tables-card-view">
                            {visibleTables.map((t) => (
                                <TableCard key={t.tableId} table={t} joinTable={joinTable} />
                            ))}
                        </div>
                    )
                ) : (
                    <div className="no-tables-found">
                        <p>No Tables Found</p>
                    </div>
                )}
            </div>
        </div>
    );
})